import React from "react";
import type { FC } from "react";
import { Radio as MaterialRadio } from "@mui/material";
import { ReactComponent as RadioSVG } from "assets/images/radio.svg";
import { ReactComponent as RadioCheckedSVG } from "assets/images/radio-checked.svg";

interface RadioProps {}

export const Radio: FC<RadioProps> = (props) => {
  return (
    <MaterialRadio
      icon={<RadioSVG />}
      checkedIcon={<RadioCheckedSVG />}
      {...props}
    />
  );
};
